import * as React from 'react';
import Box from '@mui/material/Box';
import { options } from '@config';
import Loading from '../../../../auxiliares/loading';
import IconNotifications from './IconNotifications'
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { increment, decrement, incrementByAmount, decreemenByAmount, reset  } from '../../counterSlice';

export default function NotificationsContainer () {
    const dispatch = useAppDispatch()
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 
    const [count, setCount] = React.useState(0)
    const userId = localStorage.getItem("CLUB-VIP-USER")

    const handleListNotifications = async () => {
        const response = await fetch(`${options.api.url}userid?uid=${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        const notifications = data.notifications
        let contadorAux = 0
        for (let i = 0; i < notifications.length; i++) {
            if (notifications[i].status === 'unread') contadorAux++;
        }
        dispatch(reset())
        dispatch(incrementByAmount(contadorAux))
        return contadorAux
    }

    let counterNotifications = useAppSelector(state => state.counter.value)

    React.useEffect(()=> {
        const db = handleListNotifications().then((e) => {
            // setItems(e);
            setLoading(false);
        });
    },[loading, counterNotifications]);

    return (
        <Box>
            {loading ? <Loading/>: <IconNotifications/>}
        </Box>
    )
}